import React from "react";
// css
import "./YatchOwner.css";

// YatchOwner HOME COMPONENT
const YatchOwner = () => {
  return (
    <>
      <section className="yatch_owner" id="yatch_owner">
        <div className="yatch_container">
          <hr />
          <div className="yatch_content">
            <h2>Are you a yacht owner?</h2>
            <p>
              Estimate the chartering value of your yacht and become a captain
            </p>
            <button className="join_become_btn">Join and Become a Captain</button>
          </div>
          <hr />
        </div>
      </section>
    </>
  );
};

export default YatchOwner;
